<template>
  <div class="dropdown admin-profile">
    <div
      class="d-xxl-flex align-items-center bg-transparent border-0 text-start p-0 cursor dropdown-toggle"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <div class="flex-shrink-0">
        <div
          class="rounded-circle wh-40 administrator d-flex align-items-center justify-content-center bg-primary text-white fw-bold"
          :style="{ fontSize: '16px' }"
        >
          {{ userInitials }}
        </div>
      </div>
      <div class="flex-grow-1 ms-2">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-none d-xxl-block">
            <div class="d-flex align-content-center">
              <h3>{{ userName }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown-menu border-0 bg-white dropdown-menu-end">
      <div class="d-flex align-items-center info">
        <div class="flex-shrink-0">
          <div
            class="rounded-circle wh-30 administrator d-flex align-items-center justify-content-center bg-primary text-white fw-bold"
            :style="{ fontSize: '14px' }"
          >
            {{ userInitials }}
          </div>
        </div>
        <div class="flex-grow-1 ms-2">
          <h3 class="fw-medium">{{ userFullName }}</h3>
          <span class="fs-12">{{ userRole }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const user = computed(() => {
  const stored = localStorage.getItem('user');
  return stored ? JSON.parse(stored) : null;
});

const userName = computed(() => {
  return user.value?.name?.split(' ')[0] || 'User';
});

const userFullName = computed(() => {
  return user.value?.name || 'User';
});

const userRole = computed(() => {
  if (!user.value?.roles || user.value.roles.length === 0) return '';
  return user.value.roles[0].libelle || user.value.roles[0].code || '';
});

const userInitials = computed(() => {
  if (!user.value?.name) return 'U';
  const parts = user.value.name.split(' ');
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return user.value.name.substring(0, 2).toUpperCase();
});
</script>

<style scoped>
.administrator {
  font-weight: bold;
  letter-spacing: 0.5px;
}

.wh-40 {
  width: 40px;
  height: 40px;
}

.wh-30 {
  width: 30px;
  height: 30px;
}
</style>
